export default "__VITE_ASSET__VSr1t9Zy__"